const CACHE_PREFIX = 'cache:';
const USER_CONFIG_PREFIX = `${CACHE_PREFIX}userConfig:v1:`;
const USER_SETTINGS_PREFIX = `${CACHE_PREFIX}userSettings:v1:`;

const parseTtlMs = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const APP_CONFIG_CACHE_KEY = `${CACHE_PREFIX}appConfig:v1`;
export const APP_CONFIG_TTL_MS = parseTtlMs(process.env.REACT_APP_APP_CONFIG_TTL_MS, 0);
export const USER_CONFIG_TTL_MS = parseTtlMs(process.env.REACT_APP_USER_CONFIG_TTL_MS, 0);
export const USER_SETTINGS_TTL_MS = parseTtlMs(process.env.REACT_APP_USER_SETTINGS_TTL_MS, 0);

export const getUserConfigCacheKey = (tokenHash) => `${USER_CONFIG_PREFIX}${tokenHash}`;
export const getUserSettingsCacheKey = (tokenHash) => `${USER_SETTINGS_PREFIX}${tokenHash}`;
export const getAuthUserCacheKey = (tokenHash) => `${CACHE_PREFIX}authUser:v1:${tokenHash}`;
export const AUTH_USER_TTL_MS = parseTtlMs(process.env.REACT_APP_AUTH_USER_TTL_MS, 0);

export const hashToken = (token = '') => {
    if (!token) return 'anonymous';

    let hash = 0;
    for (let i = 0; i < token.length; i += 1) {
        hash = ((hash << 5) - hash) + token.charCodeAt(i);
        hash |= 0;
    }

    return String(Math.abs(hash));
};

export const readCacheEntry = (key) => {
    if (!key) return null;

    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        const { value, cachedAt } = parsed || {};

        if (typeof cachedAt !== 'number') {
            localStorage.removeItem(key);
            return null;
        }

        return { value, cachedAt };
    } catch (error) {
        localStorage.removeItem(key);
        return null;
    }
};

export const readCache = (key, ttlMs) => {
    const entry = readCacheEntry(key);
    if (!entry) return null;

    if ((Date.now() - entry.cachedAt) > ttlMs) {
        localStorage.removeItem(key);
        return null;
    }

    return entry.value;
};

export const writeCache = (key, value) => {
    if (!key) return;
    localStorage.setItem(key, JSON.stringify({ value, cachedAt: Date.now() }));
};

export const removeCache = (key) => {
    if (!key) return;
    localStorage.removeItem(key);
};

export const removeCacheByPrefix = (prefix) => {
    if (!prefix) return;

    const keysToDelete = [];
    for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (key?.startsWith(prefix)) {
            keysToDelete.push(key);
        }
    }

    keysToDelete.forEach((key) => localStorage.removeItem(key));
};

export const clearUserScopedCaches = () => {
    removeCacheByPrefix(USER_CONFIG_PREFIX);
    removeCacheByPrefix(USER_SETTINGS_PREFIX);
};
